import * as React from 'react';

import moment from 'moment';

import { useIntl } from 'bundles/page/lib/useIntl';
import KeyInformationDetailsItem from 'bundles/unified-description-page-common/components/modules/key-information/KeyInformationDetailsItem';
import { useDurationLabels } from 'bundles/unified-description-page-common/hooks/useDurationLabels';

import _t from 'i18n!nls/xdp';

type Props = {
  totalDuration: string;
};

export const KeyInformationCourseDurationAndSchedule = ({ totalDuration }: Props) => {
  const intl = useIntl();
  let totalHours = moment.duration(totalDuration).asHours();

  totalHours = totalHours > 1 ? Math.floor(totalHours) : 1;

  const labels = useDurationLabels(totalHours, true) ?? {
    title: _t('Flexible schedule'),
    subtitle: intl.formatMessage(_t('Approx. {totalHours} {totalHours, plural, =1 {hour} other {hours}}'), {
      totalHours,
    }),
  };

  return (
    <KeyInformationDetailsItem
      title={labels.title}
      subtitle={
        <>
          {labels.subtitle && <div>{labels.subtitle}</div>}
          <div>{_t('Learn at your own pace')}</div>
        </>
      }
    />
  );
};

export default KeyInformationCourseDurationAndSchedule;
